'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _pacomo = require('utils/pacomo');

var _components2 = require('components');

var _selectors = require('selectors');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PassengerListPage = function PassengerListPage(props) {
    return _react2.default.createElement(
        'div',
        { className: 'start' },
        _react2.default.createElement(_components2.StartHeader, { className: 'StartHeader' }),
        _react2.default.createElement(_components2.PassengerListTable, {
            userCustomerId: props.userCustomerId,
            requiredApiCalls: props.requiredApiCalls,
            passengersById: props.passengersById,
            checkinUrlsByCustomerId: props.checkinUrlsByCustomerId,
            requirementSetsByCustomerId: props.requirementSetsByCustomerId
        })
    );
};
PassengerListPage.propTypes = {
    userCustomerId: _propTypes2.default.string,
    requiredApiCalls: _propTypes2.default.array.isRequired,
    passengersById: _propTypes2.default.object.isRequired,
    checkinUrlsByCustomerId: _propTypes2.default.object.isRequired,
    requirementSetsByCustomerId: _propTypes2.default.object.isRequired
};

var mapStateToProps = function mapStateToProps(state) {
    return {
        userCustomerId: state.user.customerId, // customer id of the user logged into the module (if applicable)
        requiredApiCalls: [state.apiCalls.customersData, state.apiCalls.checkinData, state.apiCalls.requirementData],
        passengersById: (0, _selectors.getCustomersById)(state),
        checkinUrlsByCustomerId: (0, _selectors.getCheckinUrlsByCustomerId)(state),
        requirementSetsByCustomerId: (0, _selectors.getRequirementSetsByCustomerId)(state)
    };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)((0, _pacomo.pacomoTransformer)(PassengerListPage));
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./app/containers/PassengerListPage.js
// module id = 1357
// module chunks = 0